import React, { useState } from "react";
import propTypes from "prop-types";

import Vimeo from "@u-wave/react-vimeo";

import Image from "../image";

import InstagramLineSvg from "../../images/icons/instagram-pure-white.inline.svg";
import LinkedInSvg from "../../images/icons/linked-in.inline.svg";
import PlayButton from "../../images/icons/play-button-blur.inline.svg";

const VideoSocialCard = ({
  active,
  title,
  featVideos,
  sourceUrl,
  cardClass = "",
  extraSocial = true,
  date = "",
  instagram = {
    className: "w-full fill-white"
  },
  linkedin = {
    className: "w-full fill-white"
  },
  socialClass = "grid grid-rows-1 grid-flow-col gap-2 items-end row-span-2",
  socialImageClass = "w-20 h-20",
  extraSocialContainerClass = "px-6 md:px-0 py-3 md:py-5",
  extraSocialNameTextClass = "font-alice dark:font-body font-light text-mob md:text-xl text-white col-span-5",
  extraSocialDateTextClass = "font-alice dark:font-body font-light text-xs text-white"
}) => {
  const [videoPaused, setVideoPlay] = useState(true);
  const vimeoId = featVideos?.slice(featVideos?.lastIndexOf("/") + 1);

  return (
    <div className={`relative video-social-card-outer-container ${cardClass}`}>
      <div
        className={`rounded-xs overflow-hidden h-5/6 sm:h-full group ${
          title ? "dark:shadow-md" : "shadow-xl"
        }`}
      >
        <div
          className={`relative h-full ${
            !videoPaused
              ? "before:hidden md:before:block before:absolute before:w-full before:h-full before:top-0 before:right-0 before:border-5 before:border-white/20 before:z-30"
              : ""
          }`}
        >
          {sourceUrl && (
            <>
              <Image
                imageAlt={""}
                image={""}
                imageClass="w-full h-full object-cover absolute right-0 left-0 top-0 bottom-0 z-10"
                sourceUrl={sourceUrl}
              />

              <button
                className="absolute top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 gvi-blur-bg rounded-full z-20"
                onClick={() => {
                  setVideoPlay(!videoPaused);
                }}
              >
                <PlayButton className={`${!active && "w-10 h-10"}`} />
              </button>
            </>
          )}

          <div
            className={`w-full h-full object-cover gvi-blur-bg  absolute top-0 right-0 left-0 bottom-0 flex items-center ${
              videoPaused === true ? "z-0" : "z-30"
            }`}
          >
            <div
              onClick={() => {
                setVideoPlay(!videoPaused);
              }}
              className={
                "absolute bg-transparent h-full w-full z-30 top-0 left-0 right-0 bottom-0 sm:z-0 rounded-md"
              }
            />
            <Vimeo
              video={vimeoId}
              className={"w-full z-20"}
              responsive={true}
              dnt={true}
              paused={videoPaused}
              onPause={() => setVideoPlay(true)}
            />
          </div>
        </div>
      </div>

      {extraSocial && (
        <div className={`extra-social-container ${extraSocialContainerClass}`}>
          <div className="justify-between grid grid-cols-6 grid-rows-2 gap-0">
            <div
              className={extraSocialNameTextClass}
              dangerouslySetInnerHTML={{
                __html: title ?? ""
              }}
            />

            {(linkedin || instagram) && (
              <div
                className={
                  socialClass
                    ? socialClass
                    : "grid grid-rows-1 grid-flow-col gap-2 items-end row-span-2"
                }
              >
                {linkedin && linkedin.url !== "" && (
                  <a href={linkedin.url} target={"_gviblank"} rel={"nofollow"}>
                    {linkedin?.icon ? (
                      <Image
                        imageAlt={""}
                        image={""}
                        imageClass={socialImageClass}
                        sourceUrl={linkedin.icon}
                      />
                    ) : (
                      <LinkedInSvg
                        className={`${
                          linkedin?.className ??
                          "h-8 fill-black-lighter dark:fill-white"
                        }`}
                      />
                    )}
                  </a>
                )}
                {instagram && instagram.url !== "" && (
                  <a href={instagram.url} target={"_gviblank"} rel={"nofollow"}>
                    {instagram?.icon ? (
                      <Image
                        imageAlt={""}
                        image={""}
                        imageClass={socialImageClass}
                        sourceUrl={instagram.icon}
                      />
                    ) : (
                      <InstagramLineSvg
                        className={`${
                          instagram?.className ??
                          "h-8 fill-black-lighter dark:fill-white"
                        }`}
                      />
                    )}
                  </a>
                )}
              </div>
            )}

            {date && (
              <div className="flex items-center col-span-5">
                <div
                  className={extraSocialDateTextClass}
                  dangerouslySetInnerHTML={{
                    __html: date
                  }}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VideoSocialCard;

VideoSocialCard.propTypes = {
  instagram: propTypes.object,
  linkedin: propTypes.object,
  cardClass: propTypes.string,
  date: propTypes.string,
  active: propTypes.bool,
  title: propTypes.string,
  featVideos: propTypes.string,
  sourceUrl: propTypes.string,
  socialClass: propTypes.string
};
